import React, { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DialogsContext from 'app/contexts/DialogsContext';
import { FileConfirmDeleteDialog } from './FileConfirmDeleteDialog';
import { useFilePlayerContext } from '../FilePlayerContext';
import { AddToPlaylistDialog } from './AddToPlaylistDialog';

export const FileListItemOptions = ({ file }) => {
  const { openDialog } = useContext(DialogsContext);
  const { deleteFilesMutation, fileSelection } = useFilePlayerContext();
  const { markFilesDeleted } = fileSelection;
  const [deleteFiles, { isLoading }] = deleteFilesMutation;

  const [anchorEl, setAnchorEl] = useState(null);
  const [showAddToPlaylist, setShowAddToPlaylist] = useState(false);

  const downloadLinkRef = useRef(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleAddToPlaylist = () => {
    setShowAddToPlaylist(true);
    handleClose();
  };

  const handleDownload = () => {
    const fixedUrl = file.original_url.replace(/^http:\/\//, 'https://');
    const encodedFilename = encodeURIComponent(file.fileName);

    downloadLinkRef.current.href = `${fixedUrl}?download=1&filename=${encodedFilename}`;
    downloadLinkRef.current.click();

    handleClose();
  };

  const handleDeleteConfirm = () => {
    deleteFiles({ ids: [file.id], permanent: 'false' });
    markFilesDeleted([file.id]);
    handleClose();
  };

  const handleDelete = (evt) => {
    openDialog({
      component: FileConfirmDeleteDialog,
      props: {
        onConfirm: handleDeleteConfirm,
      },
    });

    evt.preventDefault();
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleAddToPlaylist}>
          Add to Playlist
        </MenuItem>
        <MenuItem onClick={handleDownload}>
          Download
        </MenuItem>
        <MenuItem onClick={handleDelete} disabled={isLoading}>
          {isLoading ? 'Deleting...' : 'Move to Trash'}
        </MenuItem>
      </Menu>
      <AddToPlaylistDialog
        open={showAddToPlaylist}
        onClose={() => setShowAddToPlaylist(false)}
        purchasedItemIds={[file.id]}
      />
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a
        ref={downloadLinkRef}
        style={{ display: 'none' }}
        target="_blank"
        rel="noopener noreferrer"
        aria-hidden="true"
      />
    </>
  );
};

FileListItemOptions.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.number.isRequired,
    original_url: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
  }).isRequired,
};
